/* jshint ignore:start */
if (typeof define !== 'function') {
    var define = require('amdefine')(module)
}
/* jshint ignore:end */

define('common/utils',['lodash'], function(_) {
    'use strict';
    /**
     * regular expression for filtering URL
     * @type {RegExp}
     *
     * here:
     * ([^?#$]*) => match the domain part of URL as (www.google.com)?CID=Cust_1&p=23#portals
     * ([?]([^(#$)]*))? => match the (optional) query params of the url as www.google.com(?CID=Cust_1&p=23)#portals
     * ([#]([^#]*))? => matches the (optional) path part of the URL as www.google.com?CID=Cust_1&p=23(#portals)
     */
    var urlExp = new RegExp(/([^?#$]*)([?]([^(#$)]*))?([#]([^#]*))?/);

    return {
        parseURL: parseURL,
        createURL: createURL,
        versionHash: versionHash,
        urlEncode: urlEncode,
        cleanupObject: cleanupObject,
        createWaterfall: createWaterfall
    };


    function parseURL(url) {
        var urlParts = tokenizeURL(url);
        urlParts.query = arrayToObject(urlParts.query);
        return urlParts;
    }

    function tokenizeURL(url) {
        //  default parts of the url
        var urlParts = {
            domain: null,
            query: {},
            path: null
        };

        var tokens = url.match(urlExp);
        //  check if token is a non-empty array
        if (tokens && tokens.push && tokens.length) {
            urlParts.domain = tokens[1];
            urlParts.query = getQueryArray(tokens[3]);
            urlParts.path = tokens[5];
        }

        return urlParts;
    }

    /**
     * [createURL create a URL using the parameters;
     * @param  {string} domain [string like 'http://www.google.com' that the output URL refers]
     * @param  {Object} query  [an object that is used to create the query string of the URL;
     *         eg. {field1:value1, field2:value2}]
     * @param  {string} path   [the string that is used to create the fragment of the output URL.]
     * @return {string}        [the output URL created using the input parameters
     *         output: <domain>?<query>#<path>
     *         output: http://www.google.com?mode=guestbook&CID=Cust_1#portals]
     *         {null}   if parameters are incorrect, and URL cannot be created.
     */
    function createURL(domain, query, path) {
        var urlParts = tokenizeURL(domain),
            queryArray = Array.isArray(query) ? query : objectToArray(query),
            allowRepetition = Array.isArray(query),
            url = urlParts.domain,
            queryTokens = [],
            object;

        if (url !== '') {
            //  appending key value pairs to existing query
            urlParts.query = urlParts.query.concat(queryArray);
            //  replacing url's path
            urlParts.path = path;

            if (!allowRepetition) {
                urlParts.query = objectToArray(arrayToObject(urlParts.query));
            }


            //  creating list of query tokens
            for (var index = 0; index < urlParts.query.length; index++) {
                object = urlParts.query[index];
                if (object.key && object.value) {
                    queryTokens.push(object.key + '=' + object.value);
                }
            }

            //  appending query to url
            url = url + '?' + queryTokens.join('&');
            // to add path if path exists
            if (path) {
                url = url + '#' + path;
            }
        }

        return url;
    }

    function getQueryArray(queryString) {
        var queryArray = [];
        //  check if queryString is non-empty string
        if (queryString && queryString.match && queryString.length) {
            queryString.split('&').forEach(function(token) {
                var tokenParts = token.split('=');
                queryArray.push({
                    key: tokenParts[0],
                    value: tokenParts[1]
                });
            });
        }
        return queryArray;
    }

    function arrayToObject(array) {
        var result = {},
            object;
        for (var index = 0; index < array.length; index++) {
            object = array[index];
            if (object.key && object.value) {
                result[object.key] = object.value;
            }
        }
        return result;
    }

    function objectToArray(object) {
        var array = [];
        for (var key in object) {
            if (object.hasOwnProperty(key)) {
                array.push({
                    key: key,
                    value: object[key]
                });
            }
        }
        return array;
    }

    /**
     * Converting version to a hash value
     * @param  {String} version current ui version
     * @return {String}         hash of current UI version
     */
    function versionHash(version) {
        var versionArray = version.split('.'),
            multiplyFactor = [1, 100, 1000],
            integralValue = 0,
            index;
        for (index = 0; index < 3; index++) {
            integralValue *= multiplyFactor[index];
            integralValue += parseInt(versionArray[index] || '0', 10);
        }
        return (integralValue).toString(36);
    }

    function cleanupObject(object) {
        _.keys(object, function(key) {
            delete object[key];
        });
    }

    /**
     * function to encode url
     *
     * http://meyerweb.com/eric/tools/dencoder/
     * @param  {String} url URL to be encoded
     * @return {String}     encoded URL
     */
    function urlEncode(url) {
        return encodeURIComponent(url).replace(/'/g, '%27').replace(/"/g, '%22');
    }

    function createWaterfall(fnList) {
        var index,
            length = fnList.length,
            storage, onFinish;

        return function(data, onComplete) {
            index = -1;
            if (_.isFunction(data)) {
                onComplete = data;
                data = null;
            }
            storage = data || {};
            onFinish = onComplete || _.noop;
            _.defer(next);
        };

        function next(error) {
            ++index;
            if (error || index >= length) {
                _.defer(onFinish, error);
            } else {
                _.defer(fnList[index], storage, next);
            }
        }
    }

});
